(ns com.theplantscape.plant-web.draw.db.app-db
  (:require [reagent.core :as r]
            [datascript.core :as d]
            [com.theplantscape.plant-web.draw.db.data.tools :refer [actions]]))

(defonce schema
  {:tool/name {:db/unique :db.unique/identity}})

(defonce diag (d/create-conn schema))


(defn insert-app-data []
  (d/transact! diag (map #(assoc % :tool/usage 0) actions)))

(defonce inital-data (insert-app-data))


(def query-tools
  {:find '[(pull ?e [*])]
   :where [['?e :tool/name '?name]
           ['?e :tool/usage '?usage]]})

(defn fetch-tools []
  (flatten (d/q query-tools @diag)))

(defn update-tool-usage [name]
  (prn  "usages")
  (prn name)
  (let [tool (first (first  (d/q  '{:find [(pull ?e [*])]
                                    :in [$ ?name]
                                    :where [[?e :tool/name ?name]]}
                                  @diag name)))]
    (if tool
      (d/transact! diag [(update tool :tool/usage inc)])
      (d/transact! diag [{:tool/name name
                          :tool/usage 1}]))))

(defn tools-bind
  "Watch for transactions to the database, update atom on change."
  ([]
   (tools-bind (r/atom nil)))
  ([state]
   ;; this should be a param / unique key for the bind
   (let [db-query-key :db-tools]
     (reset! state (fetch-tools))
     (d/listen! diag db-query-key
                (fn [tx-report]
                  ;; Only update if data was modified
                  (when (:tx-data tx-report)
                    (reset! state (fetch-tools)))))
     (set! (.-__key ^js state) db-query-key)
     ;(reset! state db-query-key)
     state)))
